// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ng-0";